module.exports = __webpack_public_path__ + "static/media/userbg.3534258a.jpg";